import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import { Card, Container, Table, Row, Col } from "react-bootstrap";
import config from "../../config";
import Layout from "../../components/layouts/Main";

const MachineView = () => {
    const { id } = useParams();
    const [machine, setMachine] = useState(null);

    useEffect(() => {
        axios.get(`${config.API_BASE_URL}/machines/${id}`).then(res => setMachine(res.data));
    }, [id]);

    if (!machine) return <div>Loading...</div>;

    return (
        <Layout>
            {/* Breadcrumb */}
            <nav aria-label="breadcrumb" className="mb-3">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/">Dashboard</Link></li>
                    <li className="breadcrumb-item"><Link to="/plants">Machines</Link></li>
                    <li className="breadcrumb-item active">{machine.name}</li>
                </ol>
            </nav>

            {/* Bill Of Materials (BOM) Header */}
            <Row className="gy-3">
                <Col className="col"><h2>{machine.name}</h2></Col>
                <Col className="text-end col-auto">
                    <div className="d-flex justify-content-end flex-wrap gap-2">
                        
                    </div>
                </Col>
            </Row>
            <Container fluid className="my-4">
                <Card>
                    <Card.Body>
                        {/* <h5>Name: {machine.name}</h5>
                        <hr /> */}
                        <h6 className="text-muted mb-3">Capacities:</h6>
                        <Table bordered size="sm" className="w-auto">
                            <thead>
                                <tr>
                                    <th className="px-4 py-3">Product</th>
                                    <th className="px-4 py-3">Capacity/hr</th>
                                </tr>
                            </thead>
                            <tbody>
                                {machine.productCapacities.map((cap, idx) => (
                                    <tr key={idx}>
                                        <td className="px-4 py-2">{cap.product?.productName || "(Deleted Product)"}</td>
                                        <td className="px-4 py-2">{cap.capacityPerHour} {cap.unit}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </Container>
        </Layout>
    );
};

export default MachineView;
